import React, { FunctionComponent, ReactNode } from 'react'
import { Button, Card, Divider } from 'antd'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import SearchInput from './SearchInput/SearchInput'
import { PlusCircleFilled } from '@ant-design/icons'
import { generateRandomString } from '../../../../router/utils'

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const grid = 8

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // paddingLeft: grid * 2,
  // margin: `0 0 ${grid}px 0`,
  marginBottom: '10px',
  borderRadius: '5px',
  // change background colour if dragging
  // background: isDragging ? 'lightgrey' : 'grey',
  // styles we need to apply on draggables
  ...draggableStyle,
  width: '100%',
  display: 'flex'
})

const getListStyle = (isDraggingOver) => ({
  // background: isDraggingOver ? 'grey' : 'lightgrey',
  padding: grid
})

interface ListItem {
  id: string
  content: (index: number, length: number) => ReactNode
}

const Directions: FunctionComponent<any> = () => {

  // fake data generator
  const getItems = (count: number): ListItem[] =>
    Array.from({ length: count }, (v, k) => k).map((k: number) => ({
      id: `item-${k}-${generateRandomString(10)}`,
      content: (index: number, length: number) => (
        <SearchInput removeItem={() => removeItem(index)} />
      )
    }))

  const addItem = (): void => {
    setItems([
      ...items,
      {
        id: `item-${items.length}-${generateRandomString(10)}`,
        content: (index: number, length: number) => (
          <SearchInput removeItem={() => removeItem(index)} />
        )
      }
    ])
  }

  const [items, setItems] = React.useState<ListItem[]>(getItems(1))

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }
    setItems((prevState: ListItem[]) => {
      return reorder(prevState, result.source.index, result.destination.index) as ListItem[]
    })
  }

  const removeItem = (index: number) => {
    setItems((prevState: ListItem[]) => {
      return prevState.filter((item: ListItem, i: number) => i !== index)
    })
  }

  return (
    <Card>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'stretch' }}>
          <div style={{ flex: 10 }}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {items.map((item: ListItem, index) => (
                      <Draggable key={item.id} draggableId={item.id} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          >
                            {item.content(index, items.length)}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
        <Divider />
        <Button block={true} icon={<PlusCircleFilled />} onClick={addItem}>
          Add Destination
        </Button>
      </div>
    </Card>
  )
}

export default Directions
